<div class="ds-flex ds-flex-col">
  <message-group
    alignment="left"
    icon="bot"
    class="ds-bg-tertiary-lightergrey ds-text-primary-black"
  >
    {{ message.message }}
    <message-timestamp
      *ngIf="message.timestamp"
      [timestamp]="message.timestamp"
      class="ds-text-primary-gray"
    ></message-timestamp>
  </message-group>
</div>
